const PREFIX = 'dictaphone:autoStart:';
const STARTED_PREFIX = 'dictaphone:autoStarted:';
const AUTO_START_WINDOW_MINUTES = 15;

export function markEntryForAutoStart(entryId: string): void {
    try {
        sessionStorage.setItem(`${PREFIX}${entryId}`, '1');
    } catch {
        // ignore storage failures (private mode etc)
    }
}

// Read-only: safe to call from flows that end up not starting a recording (e.g. when
// an existing recording is restored instead). The one-shot bookkeeping happens in
// markEntryAutoStarted, called only when a recording actually auto starts.
export function shouldAutoStartRecording(entryId: string, creationTime: string): boolean {
    if (hasAutoStarted(entryId)) {
        return false;
    }

    return hasAutoStartMarker(entryId) || isWithinAutoStartWindow(creationTime);
}

export function markEntryAutoStarted(entryId: string): void {
    try {
        sessionStorage.removeItem(`${PREFIX}${entryId}`);
        sessionStorage.setItem(`${STARTED_PREFIX}${entryId}`, '1');
    } catch {
        // ignore storage failures (private mode etc)
    }
}

function isWithinAutoStartWindow(creationTime: string): boolean {
    const createdAt = new Date(creationTime).getTime();
    if (Number.isNaN(createdAt)) {
        return false;
    }

    return Date.now() - createdAt < AUTO_START_WINDOW_MINUTES * 60_000;
}

function hasAutoStartMarker(entryId: string): boolean {
    try {
        return sessionStorage.getItem(`${PREFIX}${entryId}`) !== null;
    } catch {
        return false;
    }
}

function hasAutoStarted(entryId: string): boolean {
    try {
        return sessionStorage.getItem(`${STARTED_PREFIX}${entryId}`) !== null;
    } catch {
        return false;
    }
}
